export enum legal {
  'en-US' = 'Cowbell Insurance Agency LLC, CDI License #0N04366',
  'en-GB' = 'Cowbell Cyber Ltd. and Cowbell Managing General Agency Ltd.',
}
